"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconRankingWinnerRibbon = /*#__PURE__*/
function (_Icon) {
  _inherits(IconRankingWinnerRibbon, _Icon);
  function IconRankingWinnerRibbon(props) {
    var _this;
    _classCallCheck(this, IconRankingWinnerRibbon);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconRankingWinnerRibbon).call(this, props));
    _this.name = 'IconRankingWinnerRibbon';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "ranking-winner-ribbon_svg__group0"
    }, _react2.default.createElement("path", {
      className: "ranking-winner-ribbon_svg__path0",
      d: "M18.467 23.867c-.122 0-.429-.04-.649-.411l-2.857-4.799a9.45 9.45 0 01-5.922 0l-2.857 4.799c-.22.37-.528.41-.65.41a.515.515 0 01-.059-.003c-.102-.009-.452-.076-.618-.532l-1.022-2.809-2.947.5c-.062.01-.118.015-.17.015a.706.706 0 01-.599-.291c-.059-.085-.233-.396.01-.817l3.449-5.909A9.488 9.488 0 012.5 9.632c0-5.238 4.262-9.5 9.5-9.5s9.5 4.262 9.5 9.5a9.504 9.504 0 01-1.076 4.389l3.448 5.907c.245.421.071.732.011.818a.706.706 0 01-.6.291 1.04 1.04 0 01-.169-.014l-2.948-.5-1.022 2.809c-.166.456-.516.523-.62.532a.434.434 0 01-.057.003zm-.073-1.398l.975-2.679a.502.502 0 01.55-.323l2.802.475-2.887-4.947a9.638 9.638 0 01-3.928 3.294l2.488 4.18zM4.16 19.461c.21 0 .399.132.471.329l.974 2.679 2.488-4.179a9.631 9.631 0 01-3.928-3.294l-2.887 4.946 2.799-.475a.6.6 0 01.083-.006zM12 1.132c-4.687 0-8.5 3.813-8.5 8.5 0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5 0-4.687-3.813-8.5-8.5-8.5z"
    }), _react2.default.createElement("path", {
      className: "ranking-winner-ribbon_svg__path1",
      d: "M12.5 13.132a.5.5 0 01-.5-.5v-5.3l-1.338.459a.5.5 0 11-.324-.946l2-.686a.492.492 0 01.452.066.5.5 0 01.21.407v6a.5.5 0 01-.5.5z"
    })));
    return _this;
  }
  return IconRankingWinnerRibbon;
}(_Icon3.default);
exports.default = IconRankingWinnerRibbon;